<template lang="html">
  <div>
    <d-button-group class="buttons">
      <d-button size="sm" class="btn-success" @click.prevent="editPuzzle()">
        <i class="fas fa-edit"></i><span class="d-none d-lg-inline"> Editar</span>
      </d-button>
      <!-- <a :href="siteUrl" target="_blank" class="btn btn-sm btn-primary">
        <i class="fas fa-external-link-alt"></i><span class="d-none d-lg-inline"> Visualizar</span>
      </a> -->
      <d-button size="sm" class="btn-danger" @click.prevent="confirmDeleteRow()">
        <i class="fas fa-trash"></i><span class="d-none d-lg-inline"> Deletar</span>
      </d-button>
    </d-button-group>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import { _DELETE_PUZZLE_ } from '_modules/puzzleTerm/components/PuzzleTermModel';
import config from '_config';

export default {
  name: 'puzzle-buttons',
  props: {
    puzzle: {
      type: Object,
      default: null,
    },
  },
  components: {},
  computed: {
    siteUrl() {
      return `${config.SITE_URL}${this.puzzle.slug}`;
    },
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    confirmDeleteRow() {
      this.setToggle({ type: 'confirm_modal', bool: true });
      Events.$emit(_DELETE_PUZZLE_, this.puzzle);
    },
    editPuzzle() {
      this.$emit('selectedPuzzle', this.puzzle);
    },
  },
  mounted() {},
};
</script>
